import React from 'react';
import { motion } from 'framer-motion';
import SocialMediaSection from './SocialMediaSection';
import profile from '../profile.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Profile } from '../types/profile';

const typedProfile = profile as Profile;

const containerVariants = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.11, delayChildren: 0.2 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 28, filter: 'blur(5px)' },
    visible: {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        transition: { duration: 0.65, ease: [0.25, 0.46, 0.45, 0.94] as const }
    }
};

export default function Intro(): React.ReactElement {
    return (
        <section className="min-h-screen flex items-center pt-20 pb-16">
            <div className="container-main">
                <motion.div
                    className="max-w-4xl"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    <motion.div variants={itemVariants} className="section-label mb-6">
                        <span>Software Engineer</span>
                    </motion.div>

                    <motion.h1 variants={itemVariants} className="hero-title mb-5">
                        <span className="text-gradient-hero">
                            {typedProfile['first-name']} {typedProfile['last-name']}
                        </span>
                        <span className="text-gradient">.</span>
                    </motion.h1>

                    <motion.h2 variants={itemVariants} className="hero-subtitle mb-7 max-w-2xl">
                        Building software that makes an impact.
                    </motion.h2>

                    <motion.p variants={itemVariants} className="text-[var(--color-text-secondary)] text-lg md:text-xl leading-relaxed max-w-2xl mb-8">
                        {typedProfile.bio[0]}
                        <a
                            href="https://getmembrane.com"
                            target="_blank"
                            rel="noreferrer"
                            className="text-primary-500 hover:text-primary-400 font-medium transition-colors underline decoration-primary-500/30 underline-offset-4"
                        >
                            {typedProfile.bio[1]}
                        </a>
                        {typedProfile.bio[2]}
                    </motion.p>

                    <motion.div variants={itemVariants} className="hero-meta mb-10">
                        <span>{typedProfile.experience.length} companies</span>
                        <span className="hero-meta-sep">·</span>
                        <span>Full-stack</span>
                        <span className="hero-meta-sep">·</span>
                        <span>AI &amp; developer tools</span>
                        <span className="hero-meta-sep">·</span>
                        <span>Open to opportunities</span>
                    </motion.div>

                    <motion.div variants={itemVariants} className="flex flex-wrap gap-3 mb-12">
                        <a href={`mailto:${typedProfile.email}`} className="btn-primary">
                            <FontAwesomeIcon icon={faEnvelope} />
                            <span>Get in touch</span>
                        </a>
                        <a href="#projects" className="btn-secondary">
                            <span>View my work</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </a>
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <SocialMediaSection />
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}
